:host {
  display: contents;
  --ch-window-mask-z-index: var(--ch-grid-settings-layer);
}